module.exports = __webpack_public_path__ + "img/Sleeves-Front-B9-Da-Ea-Gd.508f323f.png";